import type { ComponentCommonWelcomePageMessage, Maybe } from '@edwin-group/cj-graphql/generated/graphql';
import Container from '../Container';
import Divider from '../Divider';

export default function WelcomePageMessage({
  className,
  hideDivider,
  component,
}: {
  className?: string;
  hideDivider?: boolean;
  component?: Maybe<ComponentCommonWelcomePageMessage> | null;
}) {
  if (!component) return null;

  return (
    <Container className=" mt-sh-30 gap-sh-30">
      <div className={`col-span-12 ${className}`}>
        <h1 className="font-cadiz !text-sh-36-48">{component?.title}</h1>
        <p className="mt-sh-15 font-cadiz !text-sh-16-24">{component?.description}</p>
        {!hideDivider && <Divider className=" mb-0" />}
      </div>
    </Container>
  );
}
